// extracted by mini-css-extract-plugin
module.exports = {"wrapperMain":"style-module__wrapperMain___fxXCc","wrapperBtn":"style-module__wrapperBtn___krmIs"};